import { TextareaField } from '@/components/ui'
import { useWizardActions, useWizardInstructions } from '@/modules/analysis'

// The overall "case narrative" prompt is an input, so it stays in the editing
// column next to the sections, not in the preview sidebar.
export const OverallInstructions = () => {
  const instructions = useWizardInstructions()
  const { setInstructions } = useWizardActions()

  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <h3 className="text-[13px] font-medium text-ink-subtle">
          Case narrative
          <span className="ml-1.5 text-xs font-normal">
            (optional but highly recommended)
          </span>
        </h3>
        <p className="text-sm text-ink-subtle">
          You've already configured the details. This is where you tell Daystrom
          the bigger picture. What's the story of this case? What are you trying
          to prove, and why does it matter? This narrative ties everything
          together and helps Daystrom frame its findings around your legal
          theory, not just the numbers.
        </p>
      </div>

      <div className="[&_label]:sr-only">
        <TextareaField
          label="Case narrative"
          id="instructions"
          name="instructions"
          placeholder={`Example: "My client Jane Doe is seeking an increase in spousal support. The opposing party, John Doe, claims his income dropped after leaving his corporate role, but we believe he's funneling income through his brother's LLC. We need to show that his actual lifestyle and spending don't match what he reported on his financial affidavit."`}
          value={instructions}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
            setInstructions(event.target.value)
          }
          rows={6}
        />
      </div>
    </div>
  )
}
